<template>
	<Tooltip placement="topLeft" :overlayStyle="{ 'max-width': 'min-content' }" color="black">
		<template #title>
			<NoLineBreaks>
				{{ $t('base-stations-edit.tooltips.request.p1') }}
				<TypographyText code class="tooltip-code">%NN</TypographyText>
				{{ $t('base-stations-edit.tooltips.request.p2') }}
			</NoLineBreaks>
			<NoLineBreaks>
				{{ $t('base-stations-edit.tooltips.request.p3') }}
				<TypographyText code class="tooltip-code">${prop}</TypographyText>
				{{ $t('base-stations-edit.tooltips.request.p4') }}
				<TypographyText code class="tooltip-code">user, pass
				</TypographyText>
			</NoLineBreaks>
		</template>
		<QuestionCircleOutlined /> {{ $t('base-stations-edit.fields.request') }}
	</Tooltip>
</template>

<script>
import { Tooltip, TypographyText } from 'ant-design-vue';

import { QuestionCircleOutlined } from '@ant-design/icons-vue';

import NoLineBreaks from '@/components/common/NoLineBreaks';


export default {
	components: {
		Tooltip, TypographyText,
		QuestionCircleOutlined,
		NoLineBreaks,
	},
}
</script>
